export const routes = {
    spa: '/',
    problem: '/problem',
    task: '/task',
    solution: '/solution',
    technologies: '/technologies',
    result: '/result',
    why: '/why',
    who: '/who',
    contacts: '/contacts'
}